import { useState } from "react";
import { Table } from "react-bootstrap";
import { t } from "i18next";
import { Pagination } from "../../ui/Pagination";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { format } from "date-fns";

export const TablaHistorialPagos = ({ data, token, orderData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const nPages = Math.ceil(data.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <>
      <Table hover={false} className="historial-pagos" borderless={true}>
        <thead>
          <tr>
            <th width="10%">
              {t("pago.historial.table.cantidad")}
              <span className="order-table-icons float-end">
                <AiFillCaretDown onClick={orderData(false, 1)} />
                <AiFillCaretUp onClick={orderData(true, 1)} />
              </span>
            </th>
            <th width="40%">
              {t("pago.historial.table.concepto")}
              <span className="order-table-icons float-end">
                <AiFillCaretDown onClick={orderData(false, 2)} />
                <AiFillCaretUp onClick={orderData(true, 2)} />
              </span>
            </th>
            <th width="10%">
              {t("pago.historial.table.fecha")}
              <span className="order-table-icons float-end">
                <AiFillCaretDown onClick={orderData(false, 3)} />
                <AiFillCaretUp onClick={orderData(true, 3)} />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((pago, index) => (
            <tr key={index}>
              <td className="historial-cantidad">{pago.amount} EUR</td>
              <td
                className="historial-concepto"
                style={{ textWrap: "balance" }}
              >
                {pago.description || "-"}
              </td>
              <td className="historial-fecha">
                {pago.fecha === null ? (
                  "-"
                ) : (
                  <>
                    <span className="historial-fecha-dia">
                      {format(new Date(pago.datetime), "dd/MM/yyyy")}
                    </span>
                    <span className="historial-fecha-hora">
                      {format(new Date(pago.datetime), "HH:mm")}
                    </span>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        recordsPerPage={recordsPerPage}
        setRecordsPerPage={setRecordsPerPage}
        totalRecords={data.length}
      />
    </>
  );
};
